import baidubce from "@baiducloud/bos-uploader";
import { COU_formatDateToStr } from "@/utils/co_util";
import * as TOS from "@volcengine/tos-sdk";
import { COU_httpGet } from "@/utils/http";
export const getFormatTime = (timestamp) => {
  // 获取当前日期时间
  const year = timestamp.getFullYear(); // 年
  const month = timestamp.getMonth() + 1; // 月
  const day = timestamp.getDate(); // 日
  let clock = `${year}-`;
  if (month < 10) clock += "0";
  clock += `${month}-`;
  if (day < 10) clock += "0";
  clock += day;
  return clock;
};
// 获取上传到百度云的ak, sk, token
async function getBosSessionToken() {
  const url = `/util/bosSessionTokenV3`;
  const r = await COU_httpGet({ url });
  let result = {},
    success = false,
    msg = "";
  try {
    result = r.result;
    success = r.success;
    msg = r.msg;
  } catch (error) {
    console.log(error);
  }
  if (!result) result = {};
  return { result, success, msg };
}

// 上传到百度云的配置项
const BOS_DATA = {
  // 本地存储的key
  sessionStorageKey: "upload_config",
  // 百度云调用入口
  client: null,
  bucket: "",
  config: {
    // 域名
    endpoint: `${
      window.location.protocol.includes("https") ? "https" : "http"
    }://bj.bcebos.com`,
    credentials: {
      // STS服务器下发的临时ak
      ak: "",
      // STS服务器下发的临时sk
      sk: "",
    },
    // 临时token
    sessionToken: "",
  },
};
// 上传到TOS的配置项
const TOS_DATA = {
  sessionStorageKey: "upload_config", // 本地seesion的key
  client: null, // client实例
  bucket: "",
  config: {
    // 配置文件
    accessKeyId: "AKLTMzU0N2VjMTI1MzYyNDNhMWFhNzQyOGY0NWQxZmM1MjQ",
    accessKeySecret:
      "WWpWbFpqY3laVFJoTlRabU5ERmxPR0V5TVdKbU9XSTNPV1ZtWVROallqYw==",
    endpoint: "tos-cn-beijing.volces.com",
    region: "cn-beijing",
    sessionToken: "",
    stsToken: "",
  },
};

let serverType = 1; // 1: bos, 2: tos
// 获取本地存储的值
const getSessionData = () => {
  const data = sessionStorage.getItem(BOS_DATA.sessionStorageKey);
  return data ? JSON.parse(data) : null;
};

// 设置本地存储的值
const setSessionData = (result) => {
  result.expireTimestamp = +new Date() + (result.expires - 30) * 1000;
  result.expireTime = COU_formatDateToStr(result.expireTimestamp);
  delete result.expires;
  sessionStorage.setItem(BOS_DATA.sessionStorageKey, JSON.stringify(result));
};

// 删除对应的sessionStorage
const removeSessionData = () => {
  sessionStorage.removeItem(BOS_DATA.sessionStorageKey);
};

// 判断是否需要调用接口获取ak/sk
const isNeedGetAkData = () => {
  // 没有本地存储记录 || 没有设置过期时间 || 已过期
  return (
    !getSessionData() ||
    !getSessionData()?.expireTimestamp ||
    +new Date() > +getSessionData()?.expireTimestamp
  );
};

// 设置上传的数据
const setBosConfig = (result) => {
  serverType = result.serverType || 1; // 默认是bos
  if (result.serverType == 1) {
    // 三者缺一不可
    if (!result?.ak || !result?.sk || !result?.token) return { success: false };
    BOS_DATA.bucket = result.bucket;
    BOS_DATA.config.credentials = { ak: result.ak, sk: result.sk };
    BOS_DATA.config.sessionToken = result.token;
    BOS_DATA.client = new baidubce.sdk.BosClient(BOS_DATA.config);
    return { success: true };
  }

  if (result.serverType == 2) {
    TOS_DATA.bucket = result.bucket;
    TOS_DATA.config.region = result.region || "cn-beijing";
    TOS_DATA.config.accessKeyId = result.ak;
    TOS_DATA.config.accessKeySecret = result.sk;
    TOS_DATA.config.sessionToken = result.sessionToken;
    TOS_DATA.config.stsToken = result.token;
    TOS_DATA.client = new TOS.TosClient(TOS_DATA.config);
    return { success: true };
  }
};

// ak、sk、token (4分30秒后过期, 需要调接口获取新的)
export const GetAkData = async () => {
  // 如果需要调接口, 则调接口获取ak、sk、token, 并保存到sessionStorage里
  if (isNeedGetAkData()) {
    const { result, msg } = await getBosSessionToken();
    const { success } = await setBosConfig(result);
    if (!success)
      return { msg: msg || "获取【bos】 的数据失败, 请联系管理员 ........" };
    setSessionData(result);
  }
  // 如果还没过期, 那就从缓存里获取
  else {
    const result = getSessionData();
    const { success } = await setBosConfig(result);
    // 如果缓存里的数据缺少或没有了, 则需要清空缓存并重新调接口获取
    if (!success) {
      removeSessionData();
      return GetAkData();
    }
  }
  return { success: true };
};

// 将图片写入到百度云
const putObjectFromBlob = ({
  bucketName = "zzz-img-static2",
  path,
  file,
  mimeType,
}) => {
  return new Promise((resolve) => {
    BOS_DATA.client
      .putObjectFromBlob(bucketName, path, file, { "Content-Type": mimeType })
      .then(function () {
        resolve({ success: true });
      })
      .catch(function (res) {
        resolve({ result: res });
      });
  });
};

// 火山云上传实现
async function uploadToTOS({ key, body }) {
  console.log(TOS_DATA.bucket, key, body, "TOS_DATA.bucket");

  const res = await TOS_DATA.client.putObject({
    bucket: "staticzzb",
    key,
    body,
  });
  return res;
}

// 上传图片到百度云
export const UploadImage3 = async (file) => {
  const fileName = `${+new Date()}_${file?.name}`;
  const path = `/temp/upload_search_img/${getFormatTime(
    new Date()
  )}/${fileName}`;
  if (serverType == 1) {
    const ext = fileName.split(/\./g).pop();

    let mimeType = new baidubce.sdk.MimeType.guess(ext);
    if (/^text\//.test(mimeType)) mimeType += "; charset=UTF-8";
    const { success, result } = await putObjectFromBlob({
      path,
      file,
      mimeType,
    });
    if (!success)
      return {
        msg: `${result?.message || "上传图片失败, 请联系管理员 ........."}`,
      };
    return { imageUrl: `https://img.zzbtool.com${path}` };
  }
  if (serverType == 2) {
    const path = `temp/upload_search_img/${getFormatTime(
      new Date()
    )}/${fileName}`;
    let body = file; // 整个文件
    let r = await uploadToTOS({ key: path, body });
    if (r.statusCode != 200) return { msg: "上传图片失败!" };
    console.log(`https://static2.zzbtool.com/${path}`, "sadasdasdasd");

    return { imageUrl: `https://static2.zzbtool.com/${path}` };
  }
};

// base64文件转成file文件
export const Base64ToFile = (base64, filename) => {
  try {
    const arr = base64.split(",");
    const mime = arr[0].match(/:(.*?);/)[1];
    const suffix = mime.split("/")[1];
    const bstr = atob(arr[1]);
    let n = bstr.length;
    const u8arr = new Uint8Array(n);
    while (n--) {
      u8arr[n] = bstr.charCodeAt(n);
    }
    return new File([u8arr], `${filename || +new Date()}.${suffix}`, {
      type: mime,
    });
  } catch (error) {
    console.log("base64ToFile ....", error);
  }
};

export const fileToBase64 = (file) => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = (error) => reject(error);
  });
};

// 如果有改变原图，则需要上传到百度云再铺货
export const getSingleFinalImageUrl = async (base64) => {
  await GetAkData();
  let file = await Base64ToFile(base64);
  // 如果没有file 说明转换的时候出了问题, 那就跳过这张图片
  let { imageUrl } = await UploadImage3(file);

  return imageUrl;
};
